import React from 'react';

import AuthLogoComponent from '../../Components/CoreComponents/AuthLogoComponent';

import { Button } from 'antd';
import AuthUser from '../../Utils/user';

import './ErrorPage.css';

export const ErrorPage = () => {
  return (
    <>
      <div className="error-page">
        <div className="error-content">
          <AuthLogoComponent />
          <div className="error-inner-card">
            <h1>404</h1>
            <h4>Page Not Found</h4>
            <p>The page you`re looking for does not seem to exist</p>
            <Button href={AuthUser.getRedirectPath()} className="common-btn">
              Back to Home
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};
